import { render, staticRenderFns } from "./LittleGateDescription.vue?vue&type=template&id=71b95b96&scoped=true"
import script from "./LittleGateDescription.vue?vue&type=script&lang=ts"
export * from "./LittleGateDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b95b96",
  null
  
)

export default component.exports